
function Serialization(param) {
  var str = [];
  for (var p in param)
    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(param[p]));
  return str.join("&");

}
export default Serialization;